/**
 * Cámara y pistola leen la URL del QR: {host}/muestras/movimiento/{ID_MUESTRA}.
 * Al escribir a mano suele ir el texto de la etiqueta (campo MUESTRA), p.ej. AW25-001.
 */
export function parseMuestraScanInput(raw) {
  const text = String(raw || "").trim();
  if (!text) {
    return { kind: "empty", id: null, code: "" };
  }

  const slashMatch = text.match(/muestras\/movimiento\/(\d+)/i);
  if (slashMatch) {
    return { kind: "id", id: Number(slashMatch[1]), code: text };
  }

  const dashMatch = text.match(/muestras[-_/]+movimiento[-_/]+(\d+)/i);
  if (dashMatch) {
    return { kind: "id", id: Number(dashMatch[1]), code: text };
  }

  if (/muestra/i.test(text)) {
    const tailMatch = text.match(/(\d+)\s*$/);
    if (tailMatch) {
      return { kind: "id", id: Number(tailMatch[1]), code: text };
    }
  }

  const numeric = /^\d+$/.test(text);
  return {
    kind: "code",
    id: numeric ? Number(text) : null,
    code: text,
  };
}

export function normalizeMuestraQrCode(qrCodeText) {
  const parsed = parseMuestraScanInput(qrCodeText);
  if (parsed.kind === "id") return String(parsed.id);
  return parsed.code;
}
